/*
To implement Web Worker in Vue

1. npm install -D worker-plugin
2. make vue.config.js file in project top folder. and it's contents is ...
    --------------------------------------------------------
        const WorkerPlugin = require('worker-plugin')
        module.exports = {
        configureWebpack: {
            output: {
            globalObject: "this"
            },
            plugins: [
            new WorkerPlugin()
            ]
        }
        };
    --------------------------------------------------------
*/

let ifname=null;
const canvas_size_factor=0.8;

// construct_wv()
let canvas;
let ctx;
let refbarW=50;
let refbarH=30;
let boundRect;
let basex;          //mouse의 zero position
let basey;
let mw;
let mh;
const refbar_color='#4c5154';
const base_color='#020f10';
const acolor='#c9ffed';     //'#74f2b5';
const scolor='#ffffff';      //'#56345e';
const gcolor='yellow';
const kcolor="#ff0000";       //play pos
const measure_color='#ffffff';
const grid_color='#1d3e52';

//onSizeChanged()
let ycenter;
let yscale_wheel=0;
let yd2p_factor;

//calc_init_draw()
let mdax_selstart;
let mdax_selend;
let mdax_start;
let mdax_end;
let mdax2pax_factor;	//important!!! (mdax_end-mdax_start)이 변하면 반드시 다시 계산해 주어야 함. 예를들어 pinch zoom
let mpax2dax_factor;

//prepare_ondraw_A() 
let mpax_show0=null;
let mpax_show1=null;

//prepare_ondraw_S()
let mpsx_selstart;
let mpsx_selend;

//prepare_ondraw_W()
let xposlist;
let xstrlist;

//prepare_ondraw_H()
let yposlist;
let ystrlist;

// ETC
let mdgx=-1;        //click position
let mphx=-1;        //bottom bar를 붙들고 움직일때 핸들위치
let mpkx=-1;     //play 위치를 표시
let mData0=null;
let mData1=null;
let mChannel;
let msampling;

// editor
let mClipboard0;
let mClipboard1;
let mNumValid;
let mDeleted0;
let mDeleted1;


/////////////////////// undo 기능을 위해서 ////////////////////////
let mLastAction;
let mLast_mdax_selstart;
//let mLast_mdax_selend;




//const el = document.getElementById('mycanvas');

const UNCLICK_XY=-10000;        //x_onclick 이 이값을 가지면 click이 안된 상태임.
const DRAG_MINMOVE=5;           //클릭한 상태에서 이 값보다 많이 움직여야 drag로 인식됨

let x_onclick=UNCLICK_XY;
let y_onclick=UNCLICK_XY;
let is_drag=false;
let first_click_region=0;




let audioCtx;
let mframecnt=48000;        //1초 분량
let mframecnt2=mframecnt/2; //for double buffering
let data_rpos=0;             //input source read position
let audbuf;
let mplay_continue;
let source;
let mplay_copy_state=0;   //0:ready, 1:copy normal상태, 2:마지막 data까지 copy했음,  

    /////////////////////////////////////////////// encode.js
    
    function encode_and_save(fname, format, kbps){
        let originalBuffer=wv_download_buffer();

        DownloadFile( originalBuffer, fname, format, kbps, (val)=>{console.log(val);} );
    }
    
    function DownloadFile( originalBuffer, with_name, format, kbps, callback ) {
        let worker;
        if (format === 'mp3') {
            worker = new Worker('./lame.js', {type:'module'});
        }
        else {
            worker = new Worker('./wav.js', {type:'module'});
        }

        let sample_rate = originalBuffer.sampleRate;
        let channels = originalBuffer.channels;

        let data_left = originalBuffer.data0;
        let data_right = null;
        if (channels === 2)
            data_right = originalBuffer.data1;

        let len = data_left.length;
        let i=0;

        let dataAsInt16ArrayLeft = new Int16Array(len);
        let dataAsInt16ArrayRight = null;


        if (data_right)
        {
            dataAsInt16ArrayRight = new Int16Array(len);

            while(i < len) {
                dataAsInt16ArrayLeft[i] = convert(data_left[i]);
                 dataAsInt16ArrayRight[i] = convert(data_right[i]);
                 ++i;
            }
        }
        else
        {
            while(i < len) {
                dataAsInt16ArrayLeft[i] = convert(data_left[i]);
                 ++i;
            }
        }
        function convert ( n ) {
            return n*32767;
             //return Math.max(-32768, Math.min(32767, n * 32767)); // clamp
        }

        worker.onmessage = function( ev ) {
            if (ev.data.percentage)
            {
                callback && callback ( ev.data.percentage );
                return ;
            }
            forceDownload( ev.data );

            worker.terminate ();
            worker = null;
        }

        worker.postMessage ({
            sample_rate: sample_rate,
            kbps:!kbps ? 128 : kbps,
            channels: channels
        });
        worker.postMessage ( dataAsInt16ArrayLeft.buffer, [dataAsInt16ArrayLeft.buffer] );
        if (data_right)
            worker.postMessage ( dataAsInt16ArrayRight.buffer, [dataAsInt16ArrayRight.buffer] );
        else
            worker.postMessage (null);

        // function forceDownload ( mp3Data ) {
        // 	let blob = new Blob (mp3Data, {type:'audio/mp3'});
        function forceDownload ( blob ) {			
            let url = (window.URL || window.webkitURL).createObjectURL(blob);

            let a = document.createElement( 'a' );
            a.href = url;
            a.download = with_name ? with_name : 'output.mp3';
            a.style.display = 'none';
            document.body.appendChild( a );
            a.click();

            callback && callback ('done');
        }
    }
    
    //////////////////////////////////// ghlee_wavedit_view.js
    // Nobalab Confidential
// Programmed by Geon Hyoung Lee
// Nobalab
// infotrino@gmail.com

const	LASTACTION_UNDEFINED=0;
const	LASTACTION_ONLY_VALUE_CHANGE=1;
//const	LASTACTION_CUT=2;
//const	LASTACTION_COPY=3;
//const	LASTACTION_PASTE=4;


// convention:
// a: 파형의 일부를 보여주는 위쪽 그림에 관계되어 있을 때
// s: a region에 cut 영역을 색칠하는 것에 관계되어 있을 때
// g: click위치 표시에 관계되어 있을 때
// k: play position관련

// dx:  data 에서의 좌표
// px:  pixel 에서의 좌표

// 예를들어 dax 는 a region의 data coordinate 이다.


function wv_construct() {
    
    boundRect  =canvas.getBoundingClientRect();
    basex   =boundRect.left;
    basey   =boundRect.top;
    mw      =boundRect.width-refbarW;
    mh      =boundRect.height-refbarH;
    ycenter =mh/2;

    draw_refbarW();
    draw_refbarH();
    draw_wavebase();
    //wv_onDraw();
}

function wv_onSizeChanged() {
    boundRect  =canvas.getBoundingClientRect();
    basex   =boundRect.left;
    basey   =boundRect.top;
    mw      =boundRect.width-refbarW;
    mh      =boundRect.height-refbarH;

    //y axis
    ycenter    =mh/2;
    yd2p_factor=mh/2;

    // pixel domain variables
    //mpa_ldata=new float [mnum_adv_A];

    calc_init_draw();
}
    
function calc_init_draw(){
    // fix initial values
    mdax_selstart	=0;
    mdax_selend	    =0;

    update_mdax_start_end(0, mNumValid);

    if (mData0!==null){
        prepare_ondraw_A();
    }
    prepare_ondraw_W();
    prepare_ondraw_H();
    prepare_ondraw_S();
    wv_onDraw();
}

/////////////////////////// 파형을 그리기 위한 precalc //////////////////////////
function get_min_max(data, from, to){
    from=parseInt(from);
    to=parseInt(to);
    let tmin=1;
    let tmax=-1;
    for (let k=from; k<to; k++){
        let tdata=data[k];
        if (tdata<tmin)
            tmin=tdata;
        if (tdata>tmax)
            tmax=tdata;
    }
    return [tmin, tmax];
}

function prepareA_mono(data, ycenter, yfactor){
    let tlen=mdax_end-mdax_start;
    let pax_show;

    if (tlen<5*mw){
        let tmplow=new Int16Array(tlen);
        pax_show={low:tmplow, high:null};
        for (let k=0; k<tlen; k++){
            tmplow[k]=data[mdax_start+k]*yfactor+ycenter;
        }
    }
    else{
        let newlen=(tlen>5*mw)? mw:tlen;
        let tmplow=new Int16Array(newlen);
        let tmphigh=new Int16Array(newlen);
        pax_show={low:tmplow, high:tmphigh};

        let fac=tlen/newlen;
        for (let k=0; k<newlen; k++){
            let [tmin, tmax]=get_min_max(data, mdax_start+k*fac, mdax_start+(k+1)*fac);
            tmplow[k]=tmin*yfactor+ycenter;
            tmphigh[k]=tmax*yfactor+ycenter+1;
        }
    }
    return pax_show;
}

function prepare_ondraw_A() {
    //let tlen=mdax_end-mdax_start;
    //console.log('show= '+mdax_start+'    '+mdax_end);


    if (mChannel==1){
        let yfactor=yd2p_factor*Math.exp(-yscale_wheel*0.001);
        mpax_show0=prepareA_mono(mData0, ycenter, yfactor);
    }
    else{
        let yfactor=yd2p_factor*Math.exp(-yscale_wheel*0.001)*0.5;
        mpax_show0=prepareA_mono(mData0, ycenter/2, yfactor);
        mpax_show1=prepareA_mono(mData1, ycenter/2+ycenter, yfactor);
    }
}

function prepare_ondraw_S() {
    mpsx_selstart=dax2pax(mdax_selstart);
    mpsx_selstart=Math.min(Math.max(mpsx_selstart,0),mw);

    mpsx_selend=dax2pax(mdax_selend);
    mpsx_selend=Math.min(Math.max(mpsx_selend,0),mw);
}


function draw_refbarH(){
    ctx.fillStyle = refbar_color;
    if (mChannel==1){
        ctx.fillRect(mw, 0, refbarW, mh);
    }
    else{
        let mh2=mh>>1;
        ctx.fillRect(mw, 0, refbarW, mh2);
        ctx.fillRect(mw, mh2, refbarW, mh);
    }
}

function draw_refbarW(){
    ctx.fillStyle = refbar_color;
    ctx.fillRect(0, mh, boundRect.width, refbarH);
}

function draw_wavebase(){
    ctx.fillStyle = base_color;
    ctx.fillRect(0, 0, mw, mh);

}

// function draw_centerline(){
//     ctx.strokeStyle = '#FF0000';
//     if (mChannel==1){
//         ctx.beginPath();
//         ctx.moveTo(0, ycenter);
//         ctx.lineTo(mw, ycenter);
//         ctx.stroke();
//     }
//     else if (mChannel==2){
//         ctx.beginPath();
//         ctx.moveTo(0, ycenter/2);
//         ctx.lineTo(mw, ycenter/2);
//         ctx.moveTo(0, ycenter*3/2);
//         ctx.lineTo(mw, ycenter*3/2);
//         ctx.stroke();
//     }
// }

function wv_setData(ch, sampling, decoded_0, decoded_1) {
    if (ch>2){
        ch=2;
    }
    mChannel=ch;
    msampling=sampling;
    mData0=decoded_0;
    mData1=decoded_1;
    mNumValid=mData0.length;
    wv_onSizeChanged();
}
    
/////////////////////////////////////////////////////
function wv_ondraw_A(mpax_show){
    if (mpax_show.high==null){
        ctx.moveTo(0, mpax_show.low[0]);
        for (let k=1; k<mpax_show.low.length; k++) {
            ctx.lineTo(k*mdax2pax_factor, mpax_show.low[k]);
        }
    }
    else {
        for (let k=0; k<mpax_show.low.length; k++) {
            ctx.moveTo(k, mpax_show.low[k]);
            ctx.lineTo(k, mpax_show.high[k]);
        }
    }
}

function get_delta(dur){
    let str=dur.toString();
    let newval;
    while (true){
        let str1=str.substr(0, str.length-1);
        newval=str1*1;
        if (newval<0.000001){
            return str*1;
        }
        else{
            str=str1;
        }
    }
}

// right refbar의 마킹
function prepare_ondraw_H(){
    // const num_div=3;
    let ymaxval=32768*Math.exp(yscale_wheel*0.001);

    yposlist=new Int16Array(3);
    ystrlist=[];

    let dy=parseInt(ymaxval/2);
    if (mChannel==1){
        yposlist[0]=parseInt(mh/4);
        yposlist[1]=parseInt(mh/2);
        yposlist[2]=parseInt(mh*3/4);
    }
    else{
        yposlist[0]=parseInt(mh/4/2);
        yposlist[1]=parseInt(mh/2/2);
        yposlist[2]=parseInt(mh*3/4/2);
    }

    ystrlist.push(dy.toString());
    ystrlist.push('0');
    ystrlist.push('-'+dy.toString());
}

//bottom refbar의 마킹
function prepare_ondraw_W(){
    const num_div=6;
    let duration_sec=(mdax_end-mdax_start)/msampling;
    let delta_sec=get_delta(duration_sec/num_div);
    let idx0=Math.ceil(mdax_start/(msampling*delta_sec));
    let idx1=Math.floor(mdax_end/(msampling*delta_sec));
    let numtick=(idx1-idx0+1);
    //console.log('delta_sec= '+delta_sec);
    xposlist=new Int16Array(numtick);
    xstrlist=[];

    for (let k=idx0; k<=idx1; k++){
        let time=k*delta_sec;
        let x=time*msampling;
        let px=parseInt(dax2pax(x));
        xposlist[k-idx0]=px;
        xstrlist.push(time.toFixed(2).toString());
    }
}


function draw_h_measure(offset){
    ctx.beginPath();
    for (let k=0; k<yposlist.length; k++){
        ctx.moveTo(mw, yposlist[k]+offset);
        ctx.lineTo(mw+5, yposlist[k]+offset);
    }
    ctx.stroke();

    for (let k=0; k<yposlist.length; k++){
        ctx.fillText(ystrlist[k].toString(), mw+10, yposlist[k]+offset+4, 100);
    }
}

function draw_h_gridline(offset){
    ctx.beginPath();
    for (let k=0; k<yposlist.length; k++){
        ctx.moveTo(0, yposlist[k]+offset);
        ctx.lineTo(mw, yposlist[k]+offset);
    }
    ctx.stroke();
}

function draw_w_measure(){
    ctx.strokeStyle=measure_color;
    ctx.beginPath();
    for (let k=0; k<xposlist.length; k++){
        ctx.moveTo(xposlist[k], mh);
        ctx.lineTo(xposlist[k], mh+5);
    }
    ctx.stroke();

    ctx.fillStyle=measure_color;
    for (let k=0; k<xposlist.length; k++){
        ctx.fillText(xstrlist[k].toString(), xposlist[k]-10, mh+20, 100);
    }
}

function draw_w_gridline(){
    ctx.strokeStyle=grid_color;
    ctx.beginPath();
    for (let k=0; k<xposlist.length; k++){
        ctx.moveTo(xposlist[k], 0);
        ctx.lineTo(xposlist[k], mh);
    }
    ctx.stroke();
}

////////////////////////////////////////////// onDraw ////////////////////////////////////////////////////////////////////////////////////////////////
function wv_onDraw() {
    ctx.globalAlpha=1.0;
    draw_refbarW();
    draw_refbarH();
    draw_wavebase();


    //draw_centerline();

    //////// display W
    draw_w_measure();
    
    //////// display H
    ctx.strokeStyle=measure_color;
    ctx.fillStyle=measure_color;
    if (mChannel==1){
        draw_h_measure(0);
    }
    else{
        draw_h_measure(0);
        draw_h_measure(mh/2);
    }
    
    //horizontal grid line(by H)
    ctx.strokeStyle=grid_color;
    if (mChannel==1){
        draw_h_gridline(0);
    }
    else{
        draw_h_gridline(0);
        draw_h_gridline(mh/2);
    }

    //vertical grid line(by W)
    ctx.strokeStyle=grid_color;
    draw_w_gridline(0);

    //display A
    if (mData0!==null){
        ctx.strokeStyle=acolor;
        ctx.beginPath();
        if (mChannel==1){
            wv_ondraw_A(mpax_show0);
        }else{
            wv_ondraw_A(mpax_show0);
            wv_ondraw_A(mpax_show1);
        }
        ctx.stroke();
    }

    //display G (cursor)
    let mpgx=dax2pax(mdgx);
    if (mpgx>=0 && mpgx<mw){
        ctx.strokeStyle=gcolor;
        ctx.beginPath();
        ctx.moveTo(mpgx, 0);
        ctx.lineTo(mpgx, mh);
        ctx.stroke();
    }

    //display K (play pos)
    if (mplay_continue && mpkx>=0){
        ctx.strokeStyle=kcolor;
        ctx.beginPath();
        ctx.moveTo(mpkx, 0);
        ctx.lineTo(mpkx, mh);
        ctx.stroke();
    }
    
    // L/R 구분선
    if (mChannel==2){
        ctx.strokeStyle='#00FFFF';
        ctx.beginPath();
        ctx.moveTo(0, mh/2);
        ctx.lineTo(boundRect.width, mh/2);
        ctx.stroke();
    }

    ctx.globalAlpha=0.2;
    //display S
    ctx.fillStyle = scolor;
    ctx.fillRect(mpsx_selstart, 0, mpsx_selend-mpsx_selstart, mh);

}
/////////////////////////////////////////////////////

function wv_onclick(px){       
    console.log('onclick');
    if (first_click_region==1){     //wave region
        mdgx=Math.round(pax2dax(px));
        mdax_selstart=0;
        mdax_selend=0;
        prepare_ondraw_S();
        wv_onDraw();    
    }
    else {  //bottom bar region.  이제 드래그된다면 스크롤 필요
        mphx=px;
    }
}

function wv_ondrag(px, py, first_drag){
    if (first_click_region==1){
        if (first_drag){
            mdax_selstart=mdgx;     //Math.round(pax2dax(mpgx));
            mdax_selend=Math.round(pax2dax(px));
            mdgx=-1;
            //console.log('first drag'+mdax_selstart);
        }
        else{
            mdax_selend=Math.round(pax2dax(px));
            //console.log('drag '+x+'dx='+mdax_selend);
        }
        prepare_ondraw_S();
        wv_onDraw();    
    }
    else{   //bottom bar region.  이제 드래그된다면 스크롤 필요
        let diff_px=px-mphx;
        let diff_dx=mpax2dax_factor*diff_px;
        let x0=Math.round(mdax_start-diff_dx);
        let x1=Math.round(mdax_end-diff_dx);
        //console.log('px='+diff_px+   '   '+diff_dx);
        if (x0>=0 && x1<=mNumValid){
            update_mdax_start_end(x0, x1);
            mphx=px;
            prepare_ondraw_A();
            prepare_ondraw_W();
            prepare_ondraw_S();
            wv_onDraw();
        }
    }
}

function wv_onwheel(px, py, dy){
    if (px<mw)
        wv_onwheel_wave(px, dy);
    else
        wv_onwheel_yscale(dy);
}

function wv_onwheel_wave(px, dy){
    let x2=pax2dax(px);
    let a=Math.exp(dy*0.002);

    let x0=Math.round(a*mdax_start+(1-a)*x2);
    let x1=Math.round(a*mdax_end+(1-a)*x2);

    x0=Math.max(x0, 0);
    x1=Math.min(x1, mNumValid);

    update_mdax_start_end(x0, x1);

    //console.log('wheel:'+dy);
    prepare_ondraw_A();
    prepare_ondraw_W();
    prepare_ondraw_S();
    wv_onDraw();

}

function wv_zoomout_fullx() {
    update_mdax_start_end(0, mNumValid);
    
    prepare_ondraw_A();
    prepare_ondraw_W();
    prepare_ondraw_S();
    wv_onDraw();
}

function wv_onwheel_yscale(dy){
    yscale_wheel+=dy;
    
    prepare_ondraw_A();
    prepare_ondraw_H();
    //prepare_ondraw_S();
    wv_onDraw();

}

function wv_zoomout_fully(){
    yscale_wheel=0;
    
    prepare_ondraw_A();
    //prepare_ondraw_S();
    wv_onDraw();

}

function pax2dax(px){
    return (px*mpax2dax_factor+mdax_start);
}

function dax2pax(dx){
    return (dx-mdax_start)*mdax2pax_factor;
}

function wv_zoomtoselection() {
    if (mdax_selend-mdax_selstart!==0){
        let selmin=Math.min(mdax_selstart, mdax_selend);
        let selmax=Math.max(mdax_selstart, mdax_selend);
        update_mdax_start_end(selmin, selmax);
        prepare_ondraw_A();
        prepare_ondraw_W();
        prepare_ondraw_S();
        wv_onDraw();
    }
}

function update_mdax_start_end(x0, x1){
    mdax_start=x0;
    mdax_end=x1;
    //factor 계산
    mdax2pax_factor=mw/(mdax_end-mdax_start);	//important!!! (mdax_end-mdax_start)이 변하면 반드시 다시 계산해 주어야 함. 예를들어 pinch zoom
    mpax2dax_factor=1/mdax2pax_factor;
}

////////////////////// PLAY //////////////////////////////

function wv_get_play_region() {
    let x0;
    let x1=mNumValid;

    if (mdax_selend-mdax_selstart!==0){ //선택된 곳이 있다면
        x0=Math.min(mdax_selstart, mdax_selend);
        x1=Math.max(mdax_selstart, mdax_selend);
    }
    else {
        if (mdgx<0) {      //click된 곳이 없다면    
            x0=mdax_start;      
        }
        else {
            x0=mdgx;
        }
    }

    return [x0,x1];
}

function wv_set_play_pos(x){
    //const mp_MaxPlayMargin=mw/4;
    //const md_MaxPlayMargin=mp_MaxPlayMargin*mpax2dax_factor;
    const show_length=mdax_end-mdax_start;
    const md_MaxPlayMargin=show_length>>2;
    const mp_MaxPlayMargin=Math.round(md_MaxPlayMargin*mdax2pax_factor);

    if (x<mdax_start){      //show위치보다 이전 sample을 play하고 있는 경우
        mdax_start=x;
        mdax_end=mdax_start+show_length;
        mpkx=dax2pax(x);
    }
    else{
        //let tmp_mpkx=dax2pax(x);
        //myassert(tmp_mpkx>=0);
        if (x<=mdax_end-md_MaxPlayMargin){      //그냥 현재 play위치를 그려주면 되는 경우
            mpkx=dax2pax(x);
        }
        else{                  //mpkx를 움직일지 mdax_start를 움직일지 결정해야 함. 둘다 움직여야 할 수도 있음
            if (x+md_MaxPlayMargin<=mData0.length){
                mdax_end=x+md_MaxPlayMargin;
                mdax_start=mdax_end-show_length;
                mpkx=mw-mp_MaxPlayMargin;
                //let tmp_mpkx1=dax2pax(x);
                //assert(mpkx===tmp_mpkx1);
            }
            else{
                mdax_end=mData0.length;
                mdax_start=mdax_end-show_length;
                mpkx=dax2pax(x);
            }
        }
    }

    prepare_ondraw_A();
    prepare_ondraw_W();
    prepare_ondraw_S();
    wv_onDraw();
}

// function wv_set_play_pos(x){
//     let mid=(mdax_start+mdax_end)>>1;
//     let x_on_left_flag=(x>mdax_start && x<=mid);
//     let show_len=(mdax_end-mdax_start);
//     let x_on_end_flag=(x>(mNumValid-show_len*0.5));
//     if (x_on_left_flag || x_on_end_flag){
//         if (x_on_end_flag){
//             //console.log('x_on_end_flag'+x);
//         }
//         mpgx=dax2pax(x);
//         wv_onDraw();
//     }
//     else{
//         let offset=x-mid;
//         mdax_start+=offset;
//         mdax_end+=offset;
//         prepare_ondraw_A();
//         prepare_ondraw_W();
//         prepare_ondraw_S();
//         wv_onDraw();
//     }
// }

/////////////////////////////////////
function my_arraycopy(buf0, offset0, buf1, offset1, len){
    for (let k=0; k<len; k++){
        buf1[k+offset1]=buf0[k+offset0];
    }
}

function sel_start_end_ordering(){
    if (mdax_selend<mdax_selstart){
        let tmp=mdax_selstart;
        mdax_selstart=mdax_selend;
        mdax_selend=tmp;
    }
}

function wv_on_cut(){
    sel_start_end_ordering();
    if (mdax_selend - mdax_selstart >= 0){
        if (mChannel==1){
            mClipboard0=new Float32Array(mdax_selend-mdax_selstart);
            my_arraycopy(mData0, mdax_selstart, mClipboard0, 0, mdax_selend - mdax_selstart);
            my_arraycopy(mData0, mdax_selend, mData0, mdax_selstart, mNumValid-mdax_selend);
        }
        else{
            mClipboard0=new Float32Array(mdax_selend-mdax_selstart);
            mClipboard1=new Float32Array(mdax_selend-mdax_selstart);
            my_arraycopy(mData0, mdax_selstart, mClipboard0, 0, mdax_selend - mdax_selstart);
            my_arraycopy(mData0, mdax_selend, mData0, mdax_selstart, mNumValid-mdax_selend);
            my_arraycopy(mData1, mdax_selstart, mClipboard1, 0, mdax_selend - mdax_selstart);
            my_arraycopy(mData1, mdax_selend, mData1, mdax_selstart, mNumValid-mdax_selend);
        }
    }

    mNumValid=mNumValid+mdax_selstart-mdax_selend;
    mdax_selend=mdax_selstart;

    calc_init_draw();
}

function wv_on_copy(){
    sel_start_end_ordering();
    if (mChannel==1){
        mClipboard0=new Float32Array(mdax_selend-mdax_selstart);
        my_arraycopy(mData0, mdax_selstart, mClipboard0, 0, mdax_selend - mdax_selstart);
    }
    else{
        mClipboard0=new Float32Array(mdax_selend-mdax_selstart);
        mClipboard1=new Float32Array(mdax_selend-mdax_selstart);
        my_arraycopy(mData0, mdax_selstart, mClipboard0, 0, mdax_selend - mdax_selstart);
        my_arraycopy(mData1, mdax_selstart, mClipboard1, 0, mdax_selend - mdax_selstart);
    }
}

function wv_on_paste(){
    if (mClipboard0.length==0)
        return;

    let final_len=mNumValid+mClipboard0.length;
    let centerpos=mdgx;         

    let tmpdata;
    
    if (mChannel==1){
        tmpdata=mData0;
        mData0=new Float32Array(final_len);
        my_arraycopy(tmpdata, 0, mData0, 0, centerpos);
        my_arraycopy(mClipboard0, 0, mData0, centerpos, mClipboard0.length);
        my_arraycopy(tmpdata, centerpos, mData0, centerpos+mClipboard0.length, mNumValid-centerpos);
    }
    else {
        tmpdata=mData0;
        mData0=new Float32Array(final_len);
        my_arraycopy(tmpdata, 0, mData0, 0, centerpos);
        my_arraycopy(mClipboard0, 0, mData0, centerpos, mClipboard0.length);
        my_arraycopy(tmpdata, centerpos, mData0, centerpos+mClipboard0.length, mNumValid-centerpos);

        tmpdata=mData1;
        mData1=new Float32Array(final_len);
        my_arraycopy(tmpdata, 0, mData1, 0, centerpos);
        my_arraycopy(mClipboard1, 0, mData1, centerpos, mClipboard1.length);
        my_arraycopy(tmpdata, centerpos, mData1, centerpos+mClipboard1.length, mNumValid-centerpos);

    }
    mNumValid=final_len;
    //mdax_selstart=centerpos;
    //mdax_selend=centerpos+mClipboard.length;
    calc_init_draw();
}

function wv_on_silent(){
    save_change_region();

    if (mChannel==1){
        for (let k=mdax_selstart; k<mdax_selend; k++){
            mData0[k]=0;
        }
    }
    else {
        for (let k=mdax_selstart; k<mdax_selend; k++){
            mData0[k]=0;
            mData1[k]=0;
        }
    }
    prepare_ondraw_A();
    wv_onDraw();
}

function wv_on_fadein(){
    save_change_region();

    let factor=1./(mdax_selend-mdax_selstart);
    if (mChannel==1){
        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData0[mdax_selstart+k]=(mData0[mdax_selstart+k]*k*factor);
        }
    }
    else {
        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData0[mdax_selstart+k]=(mData0[mdax_selstart+k]*k*factor);
        }

        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData1[mdax_selstart+k]=(mData1[mdax_selstart+k]*k*factor);
        }

    }
    prepare_ondraw_A();
    wv_onDraw();
}

function wv_on_fadeout(){
    save_change_region();

    let factor=1./(mdax_selend-mdax_selstart);
    let j=mdax_selend-mdax_selstart-1;
    if (mChannel==1){
        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData0[mdax_selstart+k]=(mData0[mdax_selstart+k]*j*factor);
            j--;
        }
    }
    else {
        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData0[mdax_selstart+k]=(mData0[mdax_selstart+k]*j*factor);
            j--;
        }

        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData1[mdax_selstart+k]=(mData1[mdax_selstart+k]*j*factor);
            j--;
        }
    }

    prepare_ondraw_A();
    wv_onDraw();
}

function wv_on_amplify(factor){
    if (mdax_selstart==mdax_selend){
        mdax_selstart=0;
        mdax_selend=mData0.length;
    }
    
    save_change_region();

    if (mChannel==1){
        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData0[mdax_selstart+k]=mData0[mdax_selstart+k]*factor;
        }
    }
    else{
        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData0[mdax_selstart+k]=mData0[mdax_selstart+k]*factor;
        }
        for (let k=0; k<mdax_selend-mdax_selstart; k++){
            mData1[mdax_selstart+k]=mData1[mdax_selstart+k]*factor;
        }
    }

    prepare_ondraw_A();
    wv_onDraw();
}

function wv_on_undo(){
    // 변화된 데이터를 다시 돌려놓고
    if (mLastAction==LASTACTION_ONLY_VALUE_CHANGE){
        if (mChannel==1){
            my_arraycopy(mDeleted0, 0, mData0, mLast_mdax_selstart, mDeleted0.length);
        }
        else{
            my_arraycopy(mDeleted0, 0, mData0, mLast_mdax_selstart, mDeleted0.length);
            my_arraycopy(mDeleted1, 0, mData1, mLast_mdax_selstart, mDeleted1.length);
        }
    }

    //mDeleted는 더이상 사용되지 않으므로 malloc 해제
    mLastAction=LASTACTION_UNDEFINED;
    mDeleted0=null;
    mDeleted1=null;

    prepare_ondraw_A();
    wv_onDraw();
}

function save_change_region(){
    sel_start_end_ordering();

    if (mChannel==1){
        mDeleted0=new Float32Array(mdax_selend-mdax_selstart);
        my_arraycopy(mData0, mdax_selstart, mDeleted0, 0, mdax_selend - mdax_selstart);
    }
    else{
        mDeleted0=new Float32Array(mdax_selend-mdax_selstart);
        mDeleted1=new Float32Array(mdax_selend-mdax_selstart);
        my_arraycopy(mData0, mdax_selstart, mDeleted0, 0, mdax_selend - mdax_selstart);
        my_arraycopy(mData1, mdax_selstart, mDeleted1, 0, mdax_selend - mdax_selstart);
    }

    mLastAction			=LASTACTION_ONLY_VALUE_CHANGE;
    mLast_mdax_selstart	=mdax_selstart;
    //mLast_mdax_selend	=mdax_selend;
}

// function select_region_check(){
//     let ret=(mdax_selstart<mdax_selend);
//     return ret;
// }

function wv_download_buffer(){
    let buf={
            channels:mChannel, 
            sampleRate:msampling,
            data0: mData0,
            data1: mData1
        };
    return buf;
}

/////////////////////////////////////////// mouse.js



function onMouseDown(event) {
    if (event.button!==0)       
        return;

    let px=event.clientX-basex;
    let py=event.clientY-basey;

    if (px>mw)
        return;

    first_click_region=(py<mh)? 1:2;

    x_onclick=px;
    y_onclick=py;
    wv_onclick(x_onclick,y_onclick);
}

function onMouseUp(event) {
    //console.log(event);
    x_onclick=UNCLICK_XY;
    is_drag=false;
    first_click_region=0;
}

function onMouseMove(event){
    if (ifname===null){      //file이 열린 것이 없으면 mouse동작 안함
        return;
    }

    //console.log(event);
    if (x_onclick!==UNCLICK_XY){      //mouse down상태라면
        if (!is_drag){
            let px=event.clientX-basex;
            let py=event.clientY-basey;
            let diffx=Math.abs(px-x_onclick);
            if (diffx>=DRAG_MINMOVE){
                is_drag=true;
                wv_ondrag(px, py, true);
            }
        }
        else {
            let px=event.clientX-basex;
            let py=event.clientY-basey;
            wv_ondrag(px, py, false);
        }
    }
}

function onWheel(event) {
    event.preventDefault();
    wv_onwheel(event.clientX-basex, event.clientY-basey, event.deltaY);
}

function register_listener(canvas){
    canvas.onmousemove=onMouseMove;
    canvas.onmouseup=onMouseUp;
    canvas.onmousedown=onMouseDown;
    canvas.onwheel = onWheel;
}  

/////////////////////////////////////////// zoom.js

function onZoomPosiX(){
    let px= (mdgx>=0)? dax2pax(mdgx): mw/2;
    wv_onwheel(px, mh/2, -100);
}

function onZoomNegaX(){
    let px= (mdgx>=0)? dax2pax(mdgx): mw/2;
    wv_onwheel(px, mh/2, 100);
}


function onZoomOutfullX(){
    wv_zoomout_fullx();
}


function onZoomPosiY(){
    wv_onwheel_yscale(100);
}


function onZoomNegaY(){
    wv_onwheel_yscale(-100);
}


function onZoomOutfullY(){
    wv_zoomout_fully();
}


function onZoomToSelection(){
    wv_zoomtoselection();
}



/////////////////////////////////////////// audio_play.js
// Programmed by Geon Hyoung Lee
// Nobalab
// infotrino@gmail.com


function onPlay() {
    let [x0,x1]=wv_get_play_region();
    data_rpos=0;
    mplay_continue=true;

    audioCtx = new (window.AudioContext || window.webkitAudioContext)(
        {
            sampleRate:msampling,
            channels: mChannel
        }
    );

    audbuf = audioCtx.createBuffer(mChannel, mframecnt, audioCtx.sampleRate);   

    mplay_copy_state=1;
    copy_to_buffer(x0,x1,0);                    //copy to first buffer of double buffer
    copy_to_buffer(x0,x1,mframecnt2);           //copy to second buffer of double buffer

    // ISR
    let prev=0;
    let buffill = setInterval(function() {
        if (!mplay_continue){
            //wv_on_play_end();
            clearInterval(buffill);
        }


        //현재 play되고 있는 위치를 캔버스에 그려줌
        let curr=parseInt(audioCtx.currentTime*msampling);      //curr는 현재 play해야할 데이터를 기준으로 몇번째 sample을 play하고 있는지를 나타냄
        let x_playpos=Math.min(x0+curr, x1);
        wv_set_play_pos(x_playpos);
        //console.log('playpos='+x_playpos);

        while (curr>=mframecnt){        //now 0<=curr<mframecnt
            curr-=mframecnt;
        }

        if (prev<mframecnt2){
            if  (curr>=mframecnt2){
                copy_to_buffer(x0, x1, 0);      //half complete
            }
        }
        else {
            if (curr<mframecnt2){
                copy_to_buffer(x0, x1, mframecnt2);      //full complete
            }
        }

        prev=curr;
     }, 100);       //100msec 마다 실행
    
    audio_loop();

}


function audio_loop(){

    source = audioCtx.createBufferSource();
    //source.loop=true;
    source.buffer = audbuf;
    source.onended=audio_loop;
    source.connect(audioCtx.destination);
    source.start();

}

// [x0, x1]의 데이터를 double buffer의 어느 위치(buf_tstart)로 복사
function copy_to_buffer(x0, x1, buf_tstart){
    let src_len=x1-x0;

    if (mplay_copy_state==0){
        //console.log('copy done!!!');
        return;
    }
    else if (mplay_copy_state==2){
        //console.log('last buffer2 <--zero');
        clear_buf_sub(buf_tstart, mframecnt2);
        mplay_copy_state=3;
    }
    else if (mplay_copy_state==3){
        //console.log('last buffer3 <--zero');
        clear_buf_sub(buf_tstart, mframecnt2);
        onStop();
        mplay_copy_state=0;
    }
    else if (data_rpos+mframecnt2<=src_len){        //아직 copy할 원본이 많이 남은 상태이므로 그냥 copy
        let src_offset=x0+data_rpos;
        copy_buf_sub(src_offset, buf_tstart, mframecnt2);
        data_rpos+=mframecnt2;
        //console.log('rpos= '+data_rpos);
    }
    else{       //원본이 조금밖에 남지 않아서 그것을 copy하고 target의 뒤는 zero로 밀어버림
        let numframe=src_len-data_rpos;
        let src_offset=x0+data_rpos;
        copy_buf_sub(src_offset, buf_tstart, numframe);
        clear_buf_sub(buf_tstart+numframe, mframecnt2-numframe);
        data_rpos+=numframe;
        mplay_copy_state=2;
        //console.log('final rpos= '+data_rpos);
    }


}

function copy_buf_sub(src_offset, buf_tstart, numframe){
    //일단 left channel을 복사
    let nowBuffering = audbuf.getChannelData(0);
    for (let i = 0; i < numframe; i++) {
        nowBuffering[i+buf_tstart] = mData0[i+src_offset];
    }

    // 2 channel이라면 right channel도 복사
    nowBuffering = audbuf.getChannelData(1);
    for (let i = 0; i < numframe; i++) {
        nowBuffering[i+buf_tstart] = mData1[i+src_offset];
    }
}

function clear_buf_sub(buf_tstart, numframe){
    for (let channel = 0; channel < mChannel; channel++) {
        let nowBuffering = audbuf.getChannelData(channel);
        for (let i = 0; i < numframe; i++) {
            nowBuffering[i+buf_tstart] = 0;
        }
    }
}

function onStop() {
    source.onended=null;
    source.stop();
    mplay_continue=false;
}

/////////////////////////////////////////////// ghlee_editor.js


//////// canvas size 관련 
// window.onload= function(){
//     canvas = document.getElementById('mycanvas');
//     ctx=canvas.getContext('2d');

//     setCanvasSize();
//     wv_onSizeChanged();
//     enable_drag_drop();
//     register_listener(canvas);
//     wv_construct();
// }

function mounted(){
    canvas = document.getElementById('mycanvas');
    ctx=canvas.getContext('2d');

    setCanvasSize();
    wv_onSizeChanged();
    enable_drag_drop();
    register_listener(canvas);
    wv_construct();
}

window.onresize=function(){
    canvas = document.getElementById('mycanvas');
    ctx=canvas.getContext('2d');
    setCanvasSize();
    wv_onSizeChanged();
}

function setCanvasSize(){
    let w;
    //let h;
    w = document.body.clientWidth;
    console.log('setCanvasSize: '+w);

    let canvas=document.querySelector('#mycanvas');
    //canvas.width=w-100;
    //canvas.height=400;
    canvas.width=parseInt(w*canvas_size_factor);
    canvas.height=parseInt(canvas.width*0.4);
}

//////////// modal window (amplify)
function onAmplifyClick() {
    let inputString = prompt('Factor=', '2.0');
    let amp_factor=inputString*1.;
    wv_on_amplify(amp_factor);
}   

//////////// modal window (download)
// function onDownload() {
//     document.querySelector('.modal_wrap').style.display ='block';
//     document.querySelector('.black_bg').style.display ='block';
// }   

function onModalOK() {
    const fname = document.getElementById('outfname').value;
    const codec = document.getElementsByName('codec');
    const kbpsdoc = document.getElementsByName('kbps');

    let format;
    if (codec[0].checked)
        format='mp3';
    else if (codec[1].checked)
        format='wav';

    let kbps;
    if (kbpsdoc[0].checked)
        kbps=128;
    else if (kbpsdoc[1].checked)
        kbps=192;
    else if (kbpsdoc[2].checked)
        kbps=384;
    
    let fname_ext=fname+'.'+format;

    console.log('fname is '+fname_ext+"  "+format+ kbps);

    encode_and_save(fname_ext, format, kbps);

    //document.querySelector('.modal_wrap').style.display ='none';
    //document.querySelector('.black_bg').style.display ='none';
}

// function onModalCancel() {
//     //document.querySelector('.modal_wrap').style.display ='none';
//     //document.querySelector('.black_bg').style.display ='none';
// }

//document.getElementById('btn_amplify').addEventListener('click', onClick);
//document.querySelector('.modal_close').addEventListener('click', offClick);


///////////////////////////////////////////////////



function handleFiles(flist) {
    const reader=new FileReader();
    let file=flist[0];

    reader.readAsArrayBuffer(file);
    console.log(file);

    let audioCtxd = new (window.AudioContext || window.webkitAudioContext)(
        {
            sampleRate:16000,
        }

    );
    //let sourced = audioCtxd.createBufferSource();

    reader.onload=function(){
        ifname=file.name;
        document.getElementById('ifname').innerHTML='Filename: '+ifname;

        const pcm8=reader.result;
        audioCtxd.decodeAudioData(pcm8, function(buffer) {
            //DownloadFile(buffer, "test1.mp3", "mp3", 128, (val)=>{console.log(val);} );

            //console.log(buffer);
            if (buffer.numberOfChannels==1) {
                let decoded_0=buffer.getChannelData(0);
                wv_setData(buffer.numberOfChannels, buffer.sampleRate, decoded_0, null);
            }
            else if (buffer.numberOfChannels==2) {
                let decoded_0=buffer.getChannelData(0);
                let decoded_1=buffer.getChannelData(1);
                wv_setData(buffer.numberOfChannels, buffer.sampleRate, decoded_0, decoded_1);
            }
            
            //sourced.connect(audioCtxd.destination);
            //sourced.loop = true;
        },
        function(e){"Error with decoding audio data" + e.error});
    }

    //disable_drag_drop();
}


///////// drag 관련

// function dragstart_handler(ev) {
//     console.log("dragStart");
//     // 데이터 전달 객체에 대상 요소의 id를 추가합니다.
//     //ev.dataTransfer.setData("text/plain", ev.target.id);
// }


function dragover(ev) {
    console.log("allowDrop");
    ev.dataTransfer.dropEffect = "move";
    ev.preventDefault();
}

// function drag(ev) {
//     console.log("drag");
//     ev.dataTransfer.setData("text", ev.target.id);

// }

function drop(ev) {
    console.log(ev);
    ev.preventDefault();
    //let fname = ev.dataTransfer.files;
    handleFiles(ev.dataTransfer.files);
}

function enable_drag_drop(){
    // id를 통해 element를 가져옵니다.
    const element = document.getElementById("mycanvas");
    // 'dragstart' 이벤트 리스터를 추가합니다.
    //element.addEventListener("dragstart", dragstart_handler);
    //element.addEventListener("drag", allowDrop);
    element.addEventListener("dragover", dragover);
    element.addEventListener("drop", drop);
}

function disable_drag_drop(){
    // id를 통해 element를 가져옵니다.
    const element = document.getElementById("mycanvas");
    // 'dragstart' 이벤트 리스터를 추가합니다.
    //element.removeEventListener("dragstart", dragstart_handler);
    //element.removeEventListener("drag", allowDrop);
    element.removeEventListener("dragover", dragover);
    element.removeEventListener("drop", drop);
}

export default {handleFiles, wv_on_cut, wv_on_copy, wv_on_paste, wv_on_silent, wv_on_fadein, wv_on_fadeout, wv_on_undo,    
    onZoomPosiX, onZoomNegaX, onZoomOutfullX, onZoomPosiY, onZoomNegaY, onZoomOutfullY, onZoomToSelection, onPlay, onStop,
    onAmplifyClick, onModalOK, disable_drag_drop, mounted};